import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "rec-toast__wrapper" };
const _hoisted_3 = { class: "rec-toast__message" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 0,
    class: "rec-toast__message__secondary"
};
const _hoisted_6 = {
    key: 1,
    class: "rec-toast__buttons"
};
import { computed } from "vue";
import SvgIcon from "@/common/components/SvgIcon.vue";
import { ToastType } from "../store/toast-notifications";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ToastNotification',
    props: {
        toast: {
            type: Object,
            required: true
        }
    },
    emits: ["primary-action", "secondary-action", "close-toast"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const isPermanent = computed(() => props.toast.options?.permanent);
        const closeToast = () => {
            if (isPermanent.value)
                return;
            emits("close-toast");
        };
        const primaryAction = () => {
            emits("primary-action");
        };
        const secondaryAction = () => {
            emits("secondary-action");
        };
        const toastIcon = computed(() => {
            let icon = null;
            const src = props.toast.options?.svgIconSrc || "/svg/svg-defs.svg";
            if (props.toast.type === ToastType.SUCCESS) {
                icon = "icon-check-circle";
            }
            else if (props.toast.type === ToastType.ERROR) {
                icon = "icon-warning-hollow";
            }
            else if (props.toast.type === ToastType.DELETE) {
                icon = "icon-trash";
            }
            else if (props.toast.type === ToastType.FATAL_ERROR) {
                icon = "icon-warning-square-sync";
            }
            // Allow override
            icon = props.toast.options?.svgIcon || icon;
            return icon ? { icon, src } : null;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: _normalizeClass(["rec-toast", [
                        'rec-toast',
                        {
                            'rec-toast--type-fatal-error': __props.toast.type === _unref(ToastType).FATAL_ERROR
                        }
                    ]])
            }, [
                (!isPermanent.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "rec-toast__close",
                        "aria-label": _ctx.$t('Close'),
                        onClick: _withModifiers(closeToast, ["stop"])
                    }, [
                        _createVNode(SvgIcon, { icon: "icon-close-3" })
                    ], 8, _hoisted_1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    (toastIcon.value)
                        ? (_openBlock(), _createBlock(SvgIcon, {
                            key: 0,
                            icon: toastIcon.value.icon,
                            src: toastIcon.value.src
                        }, null, 8, ["icon", "src"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            innerHTML: __props.toast.message
                        }, null, 8, _hoisted_4),
                        (__props.toast.options?.secondaryMessage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.toast.options.secondaryMessage), 1))
                            : _createCommentVNode("", true)
                    ]),
                    (__props.toast.options?.actionButtonLabel || __props.toast.options?.secondaryActionButtonLabel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (__props.toast.options?.actionButtonLabel)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn",
                                    onClick: primaryAction
                                }, _toDisplayString(__props.toast.options?.actionButtonLabel), 1))
                                : _createCommentVNode("", true),
                            (__props.toast.options?.secondaryActionButtonLabel)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn btn-dark",
                                    onClick: secondaryAction
                                }, _toDisplayString(__props.toast.options?.secondaryActionButtonLabel), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
